import { IconSVG } from '../types';

export const AlarmOn = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 122 122"
      style={style}
    >
      <path
        fill="currentColor"
        d="M55.663 84.129l28.721-28.721-7.244-7.244-21.477 21.477L44.861 58.84l-7.243 7.244 18.045 18.046zm5.338 27.704c-6.354 0-12.306-1.207-17.855-3.622-5.55-2.415-10.379-5.676-14.488-9.785-4.109-4.11-7.37-8.939-9.785-14.488-2.415-5.55-3.622-11.501-3.622-17.855 0-6.354 1.207-12.306 3.622-17.855 2.414-5.55 5.676-10.379 9.785-14.488 4.11-4.109 8.938-7.37 14.488-9.785 5.549-2.415 11.5-3.622 17.855-3.622 6.354 0 12.306 1.207 17.855 3.622 5.55 2.414 10.379 5.676 14.488 9.785 4.109 4.11 7.37 8.938 9.785 14.488 2.415 5.549 3.622 11.5 3.622 17.855 0 6.354-1.207 12.306-3.622 17.855-2.415 5.55-5.677 10.379-9.785 14.487-4.11 4.11-8.939 7.371-14.488 9.786-5.55 2.415-11.501 3.622-17.855 3.622zM28.468 11.945l7.116 7.117L13.98 40.666 6.863 33.55l21.605-21.605zm65.066 0l21.604 21.605-7.116 7.116-21.605-21.604 7.117-7.117zm-32.533 89.721c9.912 0 18.321-3.452 25.226-10.357 6.905-6.905 10.357-15.314 10.357-25.226 0-9.913-3.452-18.321-10.357-25.226C79.322 33.952 70.913 30.5 61 30.5c-9.913 0-18.321 3.452-25.226 10.357-6.905 6.905-10.358 15.313-10.358 25.226 0 9.912 3.453 18.321 10.358 25.226C42.68 98.214 51.088 101.666 61 101.666z"
      />
    </svg>
  );
};
